// @ts-nocheck

import { createContext, useContext } from 'react';

import Subject from '../utils/subject';

type EventCenterNodeContextProps = {
  routingChannel: Subject;
  launchView: string | null;
  setLaunchView: (launchView: string | null) => void;
};

export const EventCenterNodeContext = createContext<EventCenterNodeContextProps>({
  routingChannel: new Subject(),
  launchView: null,
  setLaunchView: () => {},
});

export const useEventCenterNodeContext = () => useContext(EventCenterNodeContext);
